import React, { PropTypes } from 'react';

import MapIcon from '../MapIcon';
import Pin from '../Pin';

import '../styles.scss';


const ClusterMapMarker = ({ points, onClick }) => (
  <MapIcon onClick={onClick} styleName='cluster'>
    <Pin>
      <p>{ points }</p>
    </Pin>
  </MapIcon>
);

ClusterMapMarker.propTypes = {
  points: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ClusterMapMarker;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/MapMarker/Cluster/index.jsx